module.exports = __webpack_public_path__ + "static/media/4ODA3.16a4d240.jpg";